import { render, staticRenderFns } from "./IndexHyData5.vue?vue&type=template&id=dde6f79c"
import script from "./IndexHyData5.vue?vue&type=script&lang=js"
export * from "./IndexHyData5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports